import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import {
  BookingSuggestionsFormSchema,
  BookingSuggestionsFormValues,
} from "./booking-suggestions-form-schemas";
import { useHandymanQualifications } from "./booking-suggestions-form-hooks";
import { useEffect } from "react";

type Deps = {
  qualifications: ReturnType<typeof useHandymanQualifications>;
};

export function useBookingSuggestionsForm(deps: Deps) {
  const form = useForm<BookingSuggestionsFormValues>({
    defaultValues: {
      type: "original",
      qualification: deps.qualifications.at(0)?.name,
    },
    resolver: zodResolver(BookingSuggestionsFormSchema),
  });

  const selectedQualification: string | undefined = form.watch("qualification");

  useEffect(() => {
    if (!deps.qualifications.length) {
      return;
    }

    const selectedQualificationInList = deps.qualifications.find(
      (q) => q.name === selectedQualification
    );

    if (!selectedQualificationInList) {
      return form.setValue("qualification", deps.qualifications[0].name);
    }
  }, [deps.qualifications, selectedQualification, form]);

  return form;
}
